/** Full page reload. Extracted because jsdom's `location.reload` is unforgeable and cannot be mocked directly. */
export const reloadPage = () => {
  window.location.reload();
};
